import { render, staticRenderFns } from "./PeriodOfDaysBlock.vue?vue&type=template&id=5e19fe40"
import script from "./PeriodOfDaysBlock.vue?vue&type=script&lang=js"
export * from "./PeriodOfDaysBlock.vue?vue&type=script&lang=js"
import style0 from "./PeriodOfDaysBlock.vue?vue&type=style&index=0&id=5e19fe40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports